var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26720_101940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1645 0.878906H2.2708C1.22593 0.878906 0.378906 1.72594 0.378906 2.7708V26.2303C0.378906 27.2751 1.22593 28.1222 2.2708 28.1222H27.1645C28.2094 28.1222 29.0564 27.2751 29.0564 26.2303V2.7708C29.0564 1.72594 28.2094 0.878906 27.1645 0.878906Z",
    fill: "#E0E0E0",
    stroke: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3404 10.8258C14.9091 10.8258 14.5779 10.7259 14.3466 10.5256C14.1153 10.3253 14 10.0404 14 9.67072C14 9.29068 14.1153 9.00058 14.3466 8.80023C14.5776 8.59997 14.9088 8.5 15.3404 8.5C16.2235 8.5 16.6651 8.89049 16.6651 9.67072C16.6651 10.4409 16.2238 10.8258 15.3404 10.8258ZM15.3404 19.9C14.96 19.9 14.6702 19.7899 14.4699 19.5691C14.2696 19.3482 14.1697 19.0376 14.1697 18.6369V13.368C14.1697 12.5156 14.5598 12.0892 15.3404 12.0892C15.7104 12.0892 15.9949 12.1996 16.1952 12.4206C16.3955 12.6414 16.4955 12.9573 16.4955 13.368V18.6369C16.4955 19.0372 16.3979 19.3482 16.2029 19.5691C16.0078 19.7899 15.7201 19.9 15.3404 19.9Z",
    fill: "#424446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26720_101940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5135,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon);
export default __webpack_public_path__ + "static/media/guideIcon.bc405aa72aa2435020ef6caece21df5b.svg";
export { ForwardRef as ReactComponent };